<template>
    <main class="register-container">
        <h1>{{translate("registration_form")}}</h1>
        <form class="register-form">
            <input-custom-register :placeholder="translate('email')"
                                   data-type="email"
                                   :require=true
                                   :regex='/^(([^<>()\[\]\\.,;:\s@]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
                                   name="email"
                                   :error-msg="translate('error_msg_email')">
            </input-custom-register>
            <input-custom-register :placeholder="translate('password')"
                                   data-type="password"
                                   :require=true
                                   :regex="/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/"
                                   name="password"
                                   :error-msg="translate('error_msg_password')"
                                   v-model="primaryPassword">
            </input-custom-register>
            <input-custom-register :placeholder="translate('repeat_password')"
                                   data-type="password"
                                   :require=true
                                   :regex="/[A-Za-z0-9]/"
                                   name="password_confirmation"
                                   :error-msg="translate('error_msg_repeat_password')"
                                   v-model="confirmationPassword"
                                   :isGloballyCorrectPass="passwordMatch">
            </input-custom-register>
            <input-custom-register :placeholder="translate('company_name')"
                                   data-type="text"
                                   :require=true
                                   :regex="/[A-Za-z0-9]/"
                                   name="company_tmp"
                                   :error-msg="translate('error_msg_empty_field')">
            </input-custom-register>

            <div class="personal">
                <input-custom-register :placeholder="translate('name')"
                                       data-type="text"
                                       :require=true
                                       :regex='/[A-Za-z0-9]/'
                                       name="first_name"
                                       :error-msg="translate('error_msg_empty_field')">
                </input-custom-register>
                <input-custom-register :placeholder="translate('surname')"
                                       data-type="text"
                                       :require=true
                                       :regex='/[A-Za-z0-9]/'
                                       name="last_name"
                                       :error-msg="translate('error_msg_empty_field')">
                </input-custom-register>
            </div>
            <input-custom-register :placeholder="translate('phone')"
                                   data-type="number"
                                   :require=false
                                   :regex='/[A-Za-z0-9]/'
                                   name="phone"
                                   :error-msg="translate('error_msg_empty_field')">
            </input-custom-register>

            <terms name="Regulamin" :required=true></terms>

            <div class="navi-btns">
                <span @click="$router.go(-1)" class="back-btn circle-btn"></span>
                <button @click.prevent="tryRegister" class="registration-btn">{{translate("registration")}}</button>
            </div>
        </form>
    </main>
</template>

<script>


    import InputCustomRegister from "../components/register_inputs/inputCustomRegister";
    import Terms from "../components/register_inputs/Terms";

    export default {
        name: "Register",
        components: {Terms, InputCustomRegister},
        data() {
            return {
                value: '',
                isIncorrect: false,
                inputData: [],
                primaryPassword: '',
                confirmationPassword: '',
                passwordMatch: false
            }
        },
        watch: {
            confirmationPassword: function (value) {
                this.passwordMatch = value === this.primaryPassword;
            },
            primaryPassword: function (value) {
                this.passwordMatch = value === this.confirmationPassword;
            }
        },
        methods: {
            tryRegister(e) {
                this.$emit('getValidateData');

                if (this.isSendingDisabled) {

                    console.error('Uzupełnij wszystkie pola');

                    e.preventDefault();

                    return;

                } else {
                    this.send()
                }
            },

            send() {
                this.$apiController.registerUser(this.getFormData())
                    .then((res) => {
                        if (res.data===true) {
                            this.$router.push({path: '/login'});
                            this.$notifications.add('notification',this.translate('account_successfully_created'),this.translate('send_verification_link_on_email'));
                        } else {
                            if(res.data.includes('email_duplicate')) {
                                this.$notifications.add('warning',this.translate('account_duplicate'),this.translate('email_address_already_exsists'));
                            }
                        }
                    });
            },

            isValidationDataValid() {

                if (this.inputData.length > 0) {
                    this.inputData.forEach((item) => {
                    });
                    return !this.inputData.some((item) => item.isIncorrect === true);

                } else {
                    return false;
                }
            },

            getFormData() {
                let form = new FormData();
                for (let key of this.inputData) {
                    form.append(key.inputName, key.value);
                }
                let locale = this.$store.state.activeLang.id;
                form.append('locale', locale);
                return form;
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },

        computed: {
            isSendingDisabled() {

                return (
                    !this.isValidationDataValid()
                );
            }
        },

        mounted() {
            this.$on('validateData', (d) => {

                if (!this.inputData.some(item => item.inputName === d.inputName)) {
                    this.inputData.push(d)

                } else if (this.inputData.some(item => item.inputName === d.inputName)) {

                    this.inputData.forEach((element) => {
                        if (element.inputName === d.inputName) {
                            element.inputName = d.inputName;
                            element.isIncorrect = d.isIncorrect;
                            element.value = d.value ? d.value : '';
                        }
                    })
                }
            });
        },

        beforeDestroy() {
            this.$off('validateData');
        }

    }
</script>

<style scoped>

</style>
